// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"a9f39a54","951":"8be2c8ec"}[chunkId] + ".chunk.js";
};